<template>
    <v-col class="py-0">
        <v-carousel
            v-model="slide"
            class="mt-3"
            :show-arrows="false"
            hide-delimiters
            height="400"
        >
            <!-- Select the country where you will send from -->
            <v-carousel-item
                v-for="({ text, img }) in slides"
                :key="text"
            >
                <div>
                    <div class="text-center">
                        <v-img
                            :height="302"
                            :src="`/images/instructions/${img}`"
                            contain
                            class="mb-3 mx-auto"
                        />
                    </div>

                    <div class="mt-4 mb-4">
                        <p class="subtitle-2 mb-0">{{ text }}</p>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>

        <v-row>
            <v-col
                class="col-lg-6"
                :class="[!!slide ? 'text-center text-md-left col-4': 'text-left']"
            >
                <v-btn
                    class="text-capitalize"
                    text
                    large
                    v-if="slide !== totalSlides - 1"
                    @click="slide = totalSlides - 1"
                >
                    Skip
                </v-btn>
            </v-col>

            <v-col class="d-flex justify-md-end col-lg-6">
                <v-btn
                    class="text-capitalize px-5 rounded-lg mr-3"
                    color="amber"
                    text
                    large
                    v-if="slide > 0"
                    @click="slide -- "
                >
                    Prev
                </v-btn>
                <v-btn
                    class="text-capitalize px-5 rounded-lg"
                    color="primary"
                    dark
                    depressed
                    large
                    @click.prevent="slide++"
                    v-if="slide < totalSlides - 1"
                >
                    Next
                </v-btn>
                <v-btn
                    v-else
                    class="text-capitalize px-5 rounded-lg"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="$emit('proceed')"
                >
                    Proceed
                </v-btn>
            </v-col>
        </v-row>
    </v-col>
</template>

Select USD bank name
Enter Account Number
Click "Continue to Send"
Click "Confirm Transfer"

<script>
export default {
    data: () => ({
        slide: 0,
        totalSlides: 8,
        slides: [
            {
                text: '1. Login to Sendwave',
                img: 'sendwave-login-1.jpg'
            },
            {
                text: '2. Click the dropdown arrow and select Nigeria',
                img: 'sendwave-login-2.jpg'

            },
            {
                text: '3. Add a new recipient',
                img: 'sendwave-login-3.jpg'

            },
            {
                text: '4. Select "USD Bank Account"',
                img: 'sendwave-login-4.jpg'

            },
            {
                text: '5. Select USD bank name',
                img: 'sendwave-login-5.jpg'

            },
            {
                text: '6. Enter Account Number',
                img: 'sendwave-login-6.jpg'

            },
            {
                text: '7. Click "Continue to Send"',
                img: 'sendwave-login-7.jpg'

            },
            {
                text: '8. Click "Confirm Transfer""',
                img: 'sendwave-login-8.jpg'

            }
        ]
    }),
};
</script>
